export default __webpack_public_path__ + "static/media/open_file.84bf51a4.svg";